<template>
  <div class="IntegrationRule">
    <!-- carouse info -->
    <div class="Bglogo">
      <el-carousel trigger="click" height="330px">
        <el-carousel-item v-for="(item, index) in carouselList" :key="index">
          <img :src="item.src" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- login info -->
    <!-- <div class="loginInfo">
      <div class="BOX">
        <div class="Content">
          <el-card class="box-card">
            <div class="loginBox">
              <div class="left">
                <img src="@/assets/images/Home/user.png" />
                <span class="userInfo" v-if="token">{{ name }}</span>
                <span class="userInfo" v-else @click="handleToLogin">登 录</span>
              </div>
              <div class="right">欢 迎 访 问 斯 坦 德 检 测 积 分 商 城</div>
            </div>
            <div class="userInfoBox">
              <div class="top">
                <div class="chuck double">
                  <div v-if="token">{{ info.consumptionPoints }}</div>
                  <div v-else>0</div>
                  <div>我的积分</div>
                </div>
                <div class="chuck double">
                  <div v-if="token">{{ info.pendingIntegral }}</div>
                  <div v-else>0</div>
                  <div>待到账积分</div>
                </div>
                <div class="chuck double">
                  <div v-if="token">{{ info.freezeIntegral }}</div>
                  <div v-else>0</div>
                  <div>失效积分</div>
                </div>
                <div class="chuck Link" style="cursor: auto;">赚取积分</div>
              </div>
              <div class="bottom">
                <div class="chuck Link" @click="handleToINTEGRALRULE">积分规则</div>
                <div class="chuck Link" @click="handleToReturnGoodsPolicy">退换货政策</div>
                <div class="chuck Link" @click="handleToBulletin">商城公告</div>
                <div class="chuck Link" @click="handleToMyOrders">我的订单</div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div> -->
    
    <div class="integralBox">
      <!-- 积分规则 -->
      <div class="Rules">
          <span class="title">积 分 规 则</span>
          <div class="img">
              <img src="@/assets/images/Home/rule.png" />
          </div>
          <div class="Rules_con">
              <div class="Rules_con_chunck" v-for="(item, index) in descriptionList" :key="index">
                <a :href="`#description_chunck${index + 1}`" style="text-decoration: none; color: #2c3e50;">{{ index + 1 }}、{{ item.ruleMc }}</a>
              </div>
          </div>
      </div>

      <!-- 积分说明 -->
      <div class="description">
          <span class="title">积 分 说 明</span>
          <div class="img">
              <img src="@/assets/images/Home/rule.png" />
          </div>
          <div class="description_chunck" v-for="(item, index) in descriptionList" :id="`description_chunck${index + 1}`" :key="index">
              <div class="description_chunck_title">{{ index + 1 }}、{{ item.ruleMc }}</div>
              <div class="description_chunck_con" v-html="item.ruleDesc" style="white-space: pre-wrap;"></div>
          </div>
      </div>
    </div>

    <!-- 登录 -->
    <LoginDialog ref="LoginDialog" />

    <!-- 商城公告 -->
    <Notice ref="Notice" />
  </div>
</template>

<script>
import * as API from '@/api/user';
import LoginDialog from "@/views/Home/components/Login";
import Notice from "@/views/components/Notice";
import { mapGetters } from 'vuex';
export default {
  name: 'IntegrationRule',
  components: {
    LoginDialog,
    Notice
  },
  computed: {
    ...mapGetters(['name', 'token', 'info'])
  },
  data() {
    return {
      // 轮播图
      carouselList: [
        { src: `./Home/carousel1.jpg` }, { src: `./Home/carousel2.jpg` }, { src: `./Home/carousel3.jpg` }
      ],
      // 积分list
      descriptionList: []
    }
  },
  methods: {
    // 登录
    handleToLogin() {
      this.$refs.LoginDialog.open();
    },
    // 积分规则
    handleToINTEGRALRULE() {},
    // 退换货政策
    handleToReturnGoodsPolicy() {
      if(this.token) {
        this.$router.push({ path: "/ReturnPolicy" });
      } else {
        this.$message({ type: "error", message: "请登录用户" });
      }
    },
    // 商城公告
    handleToBulletin() {
      if(this.token) {
        this.$refs.Notice.open();
      } else {
        this.$message({ type: "error", message: "请登录用户" });
      }
    },
    // 我的订单
    handleToMyOrders() {
      if(this.token) {
        this.$router.push({ path: "/MyOrder" });
      } else {
        this.$message({ type: "error", message: "请登录用户" });
      }
    },
    GetRulesList() {
      let params = { enabled: 0 };
      API.getPointRulesDescInfo(params).then(res => {
        if(res.code === 20000) {
          if (res.data.length > 0) {
            res.data.map(item => {
              // let str = item.ruleDesc.replace("↵","<br>");
              console.log(item.ruleDesc);
              // this.$set(item, "ruleDesc", str);
            })
          }
          this.descriptionList = res.data;
        }
      });
    }
  },
  mounted() {
    this.GetRulesList();
  }
}
</script>

<style scoped>
.IntegrationRule .description {
  margin-bottom: 50px;
}
.IntegrationRule .description .description_chunck {
    padding: 36px 24px;
    border: 1px solid #8a8a8a;
    margin-bottom: 24px;
    text-align: left;
    font-weight: 700;
}
.IntegrationRule .description .description_chunck .description_chunck_title {
    padding-bottom: 12px;
    border-bottom: 1px solid #8a8a8a;
    color: #007eff;
    margin-bottom: 12px;
}
.IntegrationRule .description .description_chunck .description_chunck_con {
    line-height: 30px;
}
.IntegrationRule .Rules,
.IntegrationRule .description {
    text-align: center;
    width: 1280px;
    margin: 0 auto;
    margin-bottom: 50px;
}
.IntegrationRule .Rules .title,
.IntegrationRule .description .title {
    display: inline-block;
    background: rgb(56, 128, 202);
    padding: 8px 32px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
    border-radius: 4px;
}
.IntegrationRule .Rules .img,
.IntegrationRule .description .img {
    padding: 20px 0;
}
.IntegrationRule .Rules .Rules_con {
    overflow: hidden;
}
.IntegrationRule .Rules .Rules_con .Rules_con_chunck {
    float: left;
    padding: 16px 32px;
    border: 1px solid #8a8a8a;
    margin-bottom: 16px;
    width: 559px;
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.IntegrationRule .Rules .Rules_con .Rules_con_chunck:nth-child(2n) {
    margin-left: 20px;
}
.IntegrationRule .Bglogo {
  height: 330px;
}
.IntegrationRule .Bglogo /deep/ .el-carousel__item img {
  width: 100%;
  height: 330px;
  vertical-align: middle;
}
.IntegrationRule .Bglogo /deep/ .el-carousel__indicators--horizontal {
  top: 6%;
  left: 90%;
  transform: translateX(-50%);
}
.IntegrationRule .integralBox {
  margin: 100px 0 220px;
}
/* .IntegrationRule .loginInfo {
  height: 400px;
  position: relative;
}
.IntegrationRule .loginInfo .BOX {
  width: 1280px;
  margin: 0 auto;
}
.IntegrationRule .loginInfo .Content {
  width: 900px;
  position: absolute;
  top: -50px;
  left: 50%;
  margin-left: -450px;
  z-index: 10;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card.is-always-shadow {
  box-shadow: 0 10px 30px 0 rgba(0,0,0,.32);
}
.IntegrationRule .loginInfo .Content /deep/ .el-card {
  border-radius: 28px;
  color: #000;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body {
  height: 310px;
  overflow: auto;
  padding: 30px 50px;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .loginBox {
  overflow: hidden;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox {
  margin-top: 20px;
  border: 1px solid #000000;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox .top {
  border-bottom: 1px solid #000000;
  overflow: hidden;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox .bottom {
  overflow: hidden;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .chuck {
  border-right: 1px solid #000000;
  width: 168px;
  height: 80px;
  padding: 15px;
  float: left;
  line-height: 80px;
  font-size: 22px
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .chuck.double {
  line-height: 36px;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .chuck.Link {
  cursor: pointer;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox .top .chuck:last-child,
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .userInfoBox .bottom .chuck:last-child {
  border-right: 0;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .loginBox .left {
  float: left;
  overflow: hidden;
  cursor: pointer;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .loginBox img {
  vertical-align: middle;
  margin-right: 16px;
  float: left;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .loginBox .userInfo {
    font-size: 28px;
    float: left;
    margin-top: 10px;
}
.IntegrationRule .loginInfo .Content /deep/ .el-card .el-card__body .loginBox .right {
  float: right;
  margin-top: 20px;
  color: #868686;
  font-size: 16px;
} */
</style>
